module.exports = __webpack_public_path__ + "static/media/pause.de36e634.svg";